// import React, { useState } from "react";
// import { toast } from "react-toastify";

// const FinanceLegalSection = () => {
//   // State for uploads
//   const [registrationFile, setRegistrationFile] = useState(null);
//   const [idProof, setIdProof] = useState("");
//   const [idFile, setIdFile] = useState(null);

//   // Handlers
//   const handleFileChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       setRegistrationFile(e.target.files[0]);
//     }
//   };

//   const handleIdProofChange = (e) => {
//     setIdProof(e.target.value);
//   };

//   const handleIdFileChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       setIdFile(e.target.files[0]);
//     }
//   };

//   const handleSave = () => {
//     if (!registrationFile) {
//       toast.warn("Please upload the registration document.");
//       return;
//     }
//     if (!idProof) {
//       toast.warn("Please select an ID proof type.");
//       return;
//     }
//     if (!idFile) {
//       toast.warn("Please upload your ID proof document.");
//       return;
//     }

//     // Example: log values, replace with API call
//     console.log("Registration Document:", registrationFile);
//     console.log("ID Proof Type:", idProof);
//     console.log("ID Proof Document:", idFile);
//     toast.success("Saved successfully!");
//   };

//   return (
//     <div className="row">
//       <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-7 col-sm-12 col-12 pe-lg-5">
//         <div className="basicinfodltheadingouter">
//           <div className="dltheading">
//             <h2>Finance & Legal</h2>
//             <p>Add finance & legal details for the new listing of your property.</p>
//           </div>
//         </div>

//         <div className="row gx-3 gx-lg-4">
//           {/* Upload Registration Document */}
//           <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2">
//             <h4 className="mb-2">Upload the registration document</h4>
//             <p>Property address should be the same as mentioned on the registration document.</p>
//             <div className="infotext w-100 mt-0 mb-3">
//               <i className="icon icon-info"></i>
//               <span>
//                 To avoid rejection, please enter the address as per the registration or lease document.
//               </span>
//             </div>

//             <div className="uploadbtx dashedupload">
//               <input type="file" onChange={handleFileChange} />
//               <div className="w-100">
//                 <div className="uploadicon">
//                   <i className="icon icon-upload"></i>
//                 </div>
//                 <h4>Drag &amp; Drop the photos and videos</h4>
//                 <p>
//                   or <a href="#">click here</a> to upload
//                 </p>
//                 <p>(Upload JPEG/PNG files up to 30 MB each)</p>
//                 {registrationFile && <p className="mt-2">Selected file: {registrationFile.name}</p>}
//               </div>
//             </div>
//           </div>

//           {/* KYC - ID Proof */}
//           <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2">
//             <div className="form-group">
//               <h6>KYC - ID Proof</h6>
//               <label>Select the type of ID proof</label>
//               <div className="formgroupinner mb-2">
//                 <select className="form-select" value={idProof} onChange={handleIdProofChange}>
//                   <option value="">Select ID Proof</option>
//                   <option value="Passport">Passport</option>
//                   <option value="Aadhar Card">Aadhar Card</option>
//                   <option value="PAN Card">PAN Card</option>
//                   <option value="Driver's License">Driver's License</option>
//                 </select>
//               </div>

//               <label>Upload ID Proof Document</label>
//               <div className="uploadbtx dashedupload">
//                 <input type="file" onChange={handleIdFileChange} />
//                 <div className="w-100">
//                   <div className="uploadicon">
//                     <i className="icon icon-upload"></i>
//                   </div>
//                   <h4>Drag & Drop the ID proof document</h4>
//                   <p>
//                     or <a href="#">click here</a> to upload
//                   </p>
//                   <p>(Upload JPEG/PNG/PDF files up to 10 MB each)</p>
//                   {idFile && <p className="mt-2">Selected file: {idFile.name}</p>}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Save Button */}
//           <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
//             <div className="text-end float-start w-100">
//               <button className="theme-btn" type="button" onClick={handleSave}>
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Right Sidebar */}
//       <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-5 col-sm-12 col-12">
//         <div className="stepdlsouter">
//           <div className="steptextbx">
//             <h5>Step Detail</h5>
//             <p>
//               In this section, add the availability of your property inventory to plan your bookings in advance. You
//               must also mention the meal options & the base rate of your rooms to help us show you a clear break-up of
//               the final price & your estimated earnings.
//             </p>
//           </div>

//           <div className="accordion" id="accordionExample">
//             <h5 className="mb-2 mb-md-3">Frequently Asked Questions</h5>

//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#collapseOne"
//                   aria-expanded="false"
//                   aria-controls="collapseOne"
//                 >
//                   Aliquam eget arcu ipsum. Vivamus est tellus?
//                 </button>
//               </h2>
//               <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
//                 <div className="accordion-body">
//                   <p>
//                     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vel ornare tellus. Sed quis diam
//                     ullamcorper ante eleifend efficitur ac quis lectus. Proin ut nunc eros.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#collapseTwo"
//                   aria-expanded="true"
//                   aria-controls="collapseTwo"
//                 >
//                   In quis turpis sed enim maximus pretium sit?
//                 </button>
//               </h2>
//               <div id="collapseTwo" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
//                 <div className="accordion-body">
//                   <p>
//                     Donec pharetra dictum erat, a ullamcorper dolor placerat eu. Nam lobortis lobortis metus, et
//                     molestie tortor posuere quis.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="stepinfo">
//             <h5>Need more help?</h5>

//             <div className="stepinfobnx">
//               <div className="steptextbxicon">
//                 <i className="icon icon-user"></i>
//               </div>
//               <div className="steptextbxct">
//                 <label>Sheenam Dhingra</label>
//                 <p>Business Development Manager (BDM)</p>
//               </div>
//             </div>

//             <div className="stepinfobnx">
//               <div className="steptextbxicon">
//                 <i className="icon icon-envelope"></i>
//               </div>
//               <div className="steptextbxct">
//                 <label>
//                   <a href="mailto:sheenam.dhingra@go-mmt.com">sheenam.dhingra@go-mmt.com</a>
//                 </label>
//               </div>
//             </div>

//             <div className="stepinfobnx">
//               <div className="steptextbxicon">
//                 <i className="icon icon-phone-call"></i>
//               </div>
//               <div className="steptextbxct">
//                 <label>
//                   <a href="tel:+911234567890">+91 123 456 7890</a>
//                 </label>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FinanceLegalSection;




import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import API_BASE_URL from "../../config";

const FinanceLegalSection = () => {
  const [registrationFile, setRegistrationFile] = useState(null);
  const [existingRegistration, setExistingRegistration] = useState("");
  const [idProofType, setIdProofType] = useState("");
  const [idFile, setIdFile] = useState(null);
  const [existingIdProof, setExistingIdProof] = useState("");
  const [loading, setLoading] = useState(false);
  const [siteInfo, setSiteInfo] = useState(null);
  const [registrationPreview, setRegistrationPreview] = useState(null);
  const [idPreview, setIdPreview] = useState(null);

  /* ================= FETCH STAY DETAILS ================= */
  const fetchStayDetails = async () => {
    const stayId = localStorage.getItem("stayId");
    if (!stayId) return;

    try {
      const token = localStorage.getItem("accessToken") || "";
      const res = await axios.post(
        `${API_BASE_URL}stays/details`,
        { id: stayId },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success && res.data.data) {
        const data = res.data.data;
        setExistingRegistration(data.property_document || "");
        setExistingIdProof(data.idproof || "");
        setIdProofType(data.idprooftype || ""); //. FIXED
      }
    } catch (err) {
      console.error("Error fetching stay documents:", err);
    }
  };

  const fetchSiteInfo = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}home/info`
      );

      if (res.data.success) {
        setSiteInfo(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching site info:", err);
    }
  };

  useEffect(() => {
    fetchStayDetails();
    fetchSiteInfo();
  }, []);

  useEffect(() => {
    return () => {
      if (registrationPreview) URL.revokeObjectURL(registrationPreview);
      if (idPreview) URL.revokeObjectURL(idPreview);
    };
  }, [registrationPreview, idPreview]);

  /* ================= HANDLERS ================= */
  // const handleRegistrationChange = (e) => {
  //   if (e.target.files && e.target.files[0]) {
  //     setRegistrationFile(e.target.files[0]);
  //   }
  // };

  const handleRegistrationChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setRegistrationFile(file);

      // CREATE PREVIEW URL
      setRegistrationPreview(URL.createObjectURL(file));
    }
  };

  const handleIdProofTypeChange = (e) => {
    setIdProofType(e.target.value);
  };

  // const handleIdFileChange = (e) => {
  //   if (e.target.files && e.target.files[0]) {
  //     setIdFile(e.target.files[0]);
  //   }
  // };

  const handleIdFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setIdFile(file);

      // CREATE PREVIEW URL
      setIdPreview(URL.createObjectURL(file));
    }
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    const stayId = localStorage.getItem("stayId");

    if (!stayId) {
      toast.error("Stay ID not found");
      return;
    }

    if (!registrationFile && !idFile) {
      toast.warn("Please upload at least one document");
      return;
    }

    if (idFile && !idProofType) {
      toast.warn("Please select ID proof type");
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("accessToken") || "";
      const formData = new FormData();

      formData.append("stayId", stayId);
      formData.append("idprooftype", idProofType); //. FIXED

      if (registrationFile) {
        formData.append("property_document", registrationFile);
      }

      if (idFile) {
        formData.append("idproof", idFile);
      }

      const res = await axios.post(
        `${API_BASE_URL}stays/update-documents`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        toast.success("Documents updated successfully");
        fetchStayDetails();
        setRegistrationFile(null);
        setIdFile(null);
      } else {
        toast.error("Failed to update documents");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Error uploading documents");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-7 col-sm-12 col-12 pe-lg-5">
        <div className="basicinfodltheadingouter">
          <div className="dltheading">
            <h2>Finance & Legal</h2>
            <p>Add finance & legal details for the new listing of your property.</p>
          </div>
        </div>

        <div className="row gx-3 gx-lg-4">
          {/* ================= REGISTRATION DOCUMENT ================= */}
          <div className="col-12 mb-2">
            <h4 className="mb-2">Upload the registration document</h4>
            <p>Property address should be the same as mentioned on the registration document.</p>

            <div className="infotext w-100 mt-0 mb-3">
              <i className="icon icon-info"></i>
              <span>
                To avoid rejection, please enter the address as per the registration or lease document.
              </span>
            </div>

            {existingRegistration && (
              <p className="text-success mb-4" style={{fontSize: "20px"}}>
                Existing Document:{" "}
                <a href={existingRegistration} target="_blank" rel="noreferrer">
                  View
                </a>
              </p>
            )}

            <div className="uploadbtx dashedupload">
              <input type="file" onChange={handleRegistrationChange} />
              <div className="w-100">
                <div className="uploadicon">
                  <i className="icon icon-upload"></i>
                </div>
                <h4>Drag & Drop the photos and videos</h4>
                <p>
                  or <a href="#">click here</a> to upload
                </p>
                <p>(Upload JPEG/PNG/PDF files up to 30 MB each)</p>
                {registrationFile && (
                  <p className="mt-2">Selected file: {registrationFile.name}</p>
                )}
              </div>
            </div>
          </div>

          {registrationPreview && (
            <div className="mt-3">
              <h6>Preview:</h6>

              {registrationFile?.type?.includes("image") ? (
                <img
                  src={registrationPreview}
                  alt="Preview"
                  style={{ width: "200px", borderRadius: "8px" }}
                />
              ) : registrationFile?.type === "application/pdf" ? (
                <object
                  data={registrationPreview}
                  type="application/pdf"
                  width="100%"
                  height="300px"
                  style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                >
                  <p>
                    PDF preview not supported.{" "}
                    <a href={registrationPreview} target="_blank" rel="noreferrer">
                      Open PDF
                    </a>
                  </p>
                </object>
              ) : (
                <a href={registrationPreview} target="_blank" rel="noreferrer">
                  Open File
                </a>
              )}
            </div>
          )}

          {/* ================= KYC ================= */}
          <div className="col-12 mb-2">
            <div className="form-group">
              <h6>KYC - ID Proof</h6>

              <label>Select the type of ID proof</label>
              <div className="formgroupinner mb-2">
                <select
                  className="form-select"
                  value={idProofType}
                  onChange={handleIdProofTypeChange}
                >
                  <option value="">Select ID Proof</option>
                  <option value="Passport">Passport</option>
                  <option value="Aadhar Card">Aadhar Card</option>
                  <option value="PAN Card">PAN Card</option>
                  <option value="Driver's License">Driver's License</option>
                </select>
              </div>

              {existingIdProof && (
                <p className="text-success mb-4" style={{fontSize: "20px"}}>
                  Existing ID Proof:{" "}
                  <a href={existingIdProof} target="_blank" rel="noreferrer">
                    View
                  </a>
                </p>
              )}

              <label>Upload ID Proof Document</label>
              <div className="uploadbtx dashedupload">
                <input type="file" onChange={handleIdFileChange} />
                <div className="w-100">
                  <div className="uploadicon">
                    <i className="icon icon-upload"></i>
                  </div>
                  <h4>Drag & Drop the ID proof document</h4>
                  <p>
                    or <a href="#">click here</a> to upload
                  </p>
                  <p>(Upload JPEG/PNG/PDF files up to 10 MB each)</p>
                  {idFile && <p className="mt-2">Selected file: {idFile.name}</p>}
                </div>
              </div>
            </div>
          </div>

          {idPreview && (
            <div className="mt-3">
              <h6>Preview:</h6>

              {idFile?.type?.includes("image") ? (
                <img
                  src={idPreview}
                  alt="Preview"
                  style={{ width: "200px", borderRadius: "8px" }}
                />
              ) : idFile?.type === "application/pdf" ? (
                <object
                  data={idPreview}
                  type="application/pdf"
                  width="100%"
                  height="300px"
                  style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                >
                  <p>
                    PDF preview not supported.{" "}
                    <a href={idPreview} target="_blank" rel="noreferrer">
                      Open PDF
                    </a>
                  </p>
                </object>
              ) : (
                <a href={idPreview} target="_blank" rel="noreferrer">
                  Open File
                </a>
              )}
            </div>
          )}

          {/* ================= SAVE ================= */}
          <div className="col-12 mt-3">
            <div className="text-end float-start w-100">
              <button
                className="theme-btn"
                type="button"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? "Uploading..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ================= RIGHT SIDEBAR ================= */}
      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-5 col-sm-12 col-12">
        <div className="stepdlsouter">
          {/* <div className="steptextbx">
            <h5>Step Detail</h5>
            <p>
              In this section, add the availability of your property inventory to plan your bookings in advance.
            </p>
          </div>

          <div className="accordion" id="accordionExample">
            <h5 className="mb-2 mb-md-3">Frequently Asked Questions</h5>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                >
                  Aliquam eget arcu ipsum. Vivamus est tellus?
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse">
                <div className="accordion-body">
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                >
                  In quis turpis sed enim maximus pretium sit?
                </button>
              </h2>
              <div id="collapseTwo" className="accordion-collapse collapse show">
                <div className="accordion-body">
                  <p>Donec pharetra dictum erat.</p>
                </div>
              </div>
            </div>
          </div> */}

          <div className="stepinfo">
            <h5>Need more help?</h5>

            {siteInfo && (
              <>
                <div className="stepinfobnx">
                  <div className="steptextbxicon">
                    <i className="icon icon-envelope"></i>
                  </div>
                  <div className="steptextbxct">
                    <label>
                      <a href={`mailto:${siteInfo.site_email}`}>
                        {siteInfo.site_email}
                      </a>
                    </label>
                  </div>
                </div>

                <div className="stepinfobnx">
                  <div className="steptextbxicon">
                    <i className="icon icon-phone"></i>
                  </div>
                  <div className="steptextbxct">
                    <label>
                      <a href={`tel:${siteInfo.site_phone}`}>
                        {siteInfo.site_phone}
                      </a>
                    </label>
                  </div>
                </div>

                <div className="stepinfobnx">
                  <div className="steptextbxicon">
                    <i className="icon icon-phone-call"></i>
                  </div>
                  <div className="steptextbxct">
                    <label>
                      <a
                        href={`https://wa.me/${siteInfo.support_whatsapp}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Chat on WhatsApp
                      </a>
                    </label>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinanceLegalSection;


